// @ts-nocheck
import { Button, Typography } from "@insite/mobius/index";
import { CustomWidgetModule } from "@store/Framework/Types/types";

import InfosBox from "@store/Library/Components/Toolkit/InfosBox";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import useSignatureData from "@store/Framework/Common/Hooks/useSignatureData";
import SigningModal from "@store/Library/Components/Signature/SigningModal";
import SignatureIcon from "@store/Library/Widgets/SignatureIntegration/SignatureIcon";
import React from "react";
import styled from "styled-components";

const StyledButton = styled(Button)`
    display: flex;
    column-gap: 0.5rem;
    margin-block: 1rem;
`;
enum fields {
    editable = "editable",
}

interface SignatureButtonProps extends WidgetProps {
    fields: {
        [fields.editable]: boolean;
    };
}
const SignatureIntegration: React.FC<SignatureButtonProps> = ({ fields }) => {
    const { editable } = fields;
    const [showModal, setShowModal] = React.useState(false);
    const { signatureData, setSignature } = useSignatureData();
    const showButton = editable || signatureData.customerName;
    return (
        <>
            {showButton && (
                <StyledButton sizeVariant="medium" onClick={() => setShowModal(true)}>
                    <SignatureIcon /> <Typography>{translate("Confirmation Of Receipt")}</Typography>
                </StyledButton>
            )}
            {!showButton && <InfosBox type="warning">{siteMessage("SignaturePad_NotSigned")}</InfosBox>}
            <SigningModal
                onClose={() => setShowModal(false)}
                setSignatureState={setSignature}
                signatureData={signatureData}
                editable={editable}
                isOpen={showModal}
            />
        </>
    );
};

const widgetModule: CustomWidgetModule = {
    component: SignatureIntegration,
    definition: {
        group: "SignaturePad",
        displayName: "SignaturePad",
        fieldDefinitions: [
            {
                name: fields.editable,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                displayName: "Editable",
            },
        ],
    },
};

export default widgetModule;
